export const LOGIN_USER = 'login-user';
export const CHANGE_LANGUGAE = 'change-language/supplier';

export const USER_LOGO = 'user-logo/store';
export const UPDATE_PROFILE = 'update-profile/supplier';
export const UPDATE_PASSWORD = 'update-password/supplier';
export const GET_USER_PROFILE = 'get-user-profile/supplier';
export const PROFILE_IMAGE_UPLOAD = 'profile-image-upload/supplier';

export const GET_CATEOGRY = 'get-category';
export const EDIT_CATEGORY = 'edit-category';
export const ADD_CATEGORY = 'add-category';
export const GET_CATEGORIES_LIST = 'get-categories-list';

export const GET_INGREDIENTS = 'get-ingredients';
export const CREATE_INGREDIENT = 'create-ingredient';

export const GET_OUTER_INVOICE_LIST = 'get-outer-invoice-list/supplier';
export const GET_INNER_INVOICE_LIST = 'get-inner-invoice-list/supplier';
export const GET_INVOICE_BY_ID = 'get-invoice-by-id/supplier';
export const CREATE_INVOICE = 'create-invoice';

export const GET_REPLIES = 'get-replies/supplier';
export const REPLY_MESSAGE = 'reply-message/supplier';
export const SEND_MESSAGES = 'send-messages/supplier';
export const DELETE_MESSAGE = 'delete-message/supplier';
export const GET_MESSAGE_LIST = 'get-message-list/supplier';
export const CHANGE_MESSAGE_STATUS = 'change-message-status/supplier';
export const GET_NAMES_SUPPLIER = 'get-names/supplier';
export const GET_NEW_MESSAGE_COUNT = 'get-new-message-count/supplier';

export const GET_ALL_STORES = 'get-all-stores/supplier';

export const GET_ORDER_PROCESSING = 'get-order-processing';

export const CANCEL_ORDER = 'cancel-order';
export const GET_NEW_ORDERS = 'get-new-orders';
export const CREATE_NOTE = 'create-note/supplier';
export const UPDATE_ORDER_STATUS = 'update-order-status';
export const GET_ORDERS_SUPPLIER = 'get-orders-supplier';
export const GET_ORDER_BY_ID = 'get-order-by-id/supplier';
export const PACKED_ORDER = 'status-change-packed';
export const SHIPPED_ORDER = 'add-shipping';
export const GET_NEW_ORDER_COUNT = 'get-new-orders-count';

export const GET_PRODUCT_STORE_ORDERS = 'get-product-store-orders';
export const INNER_PRODUCTION_STORE_DETAILS = 'inner-production-store-details';
export const OUTER_PRODUCTION_STORE_DETAILS = 'outer-production-store-details';
export const CONFIRM_PRODUCTION = 'confirm-production';

export const PRODUCT_FILE = 'product-file';
export const GET_PRODUCTS = 'get-products';
export const EDIT_PRODUCT = 'edit-product';
export const CREATE_PRODUCT = 'create-product';
export const GET_PRODUCT = 'get-product/supplier';
export const REACTIVE_PRODUCT = 'reactive-product';
export const DEACTIVE_PRODUCT = 'deactive-product';
export const GET_PRODUCT_NAMES = 'get-product-names';
export const UNAVAILABLE_PRODUCT = 'unavailable-product';
export const GET_PRODUCTS_SUPPLIER = 'get-products/supplier';

export const GET_CATEGORIES = 'get-categories';
export const GET_SUB_CATEGORIES = 'get-subcategories';

export const GET_RECIPE_BY_PRODUCT = 'get-recipe-by-product';
export const INNER_CONSOLIDATED_MULTIPLE_PRODUCT = 'inner-consolidated-multiple-product';
export const OUTER_CONSOLIDATED_MULTIPLE_PRODUCT = 'outer-consolidated-multiple-product';

// export const GET_SHIPPED_LIST = 'get-shipped-list/supplier';
export const GET_SHIPPING_LIST = 'get-shipping-list/supplier';
// export const GET_SHIPPED_BY_ID = 'get-shipped-by-id/supplier';
export const GET_SHIPPING_BY_ID = 'get-shipping-by-id/supplier';

export const EDIT_STORE = 'edit-store';
export const GET_STORES = 'get-stores';
export const CREATE_STORE = 'create-store';
export const GET_STORE = 'get-store/supplier';
export const REACTIVE_STORE = 'reactive-store';
export const DEACTIVE_STORE = 'deactive-store';
export const GET_STORE_PRODUCTS = 'get-store-products/supplier';
export const ASSIGN_UNASSIGN_PRODUCTS = 'assign-unassign-products';

export const ADD_SUB_CATEGORY = 'add-subcategory';
export const EDIT_SUB_CATEGORY = 'edit-subcategory';
export const GET_SUB_CATEGORIES_LIST = 'get-subcategories-list/supplier';

export const GET_TAXES = 'get-taxes/supplier';
export const CREATE_TAXES = 'create-taxes/supplier';
export const GET_SHIPPING_METHODS = 'get-shipping-methods';
export const CREATE_SHIPPING_METHOD = 'create-shipping-method';

export const GET_COUNTRY_LIST = 'get-country-list/supplier';
export const GET_STATE_LIST = 'get-state-list/supplier';

export const ACTIVE_ORDERS = 'active-orders';
export const UPDATE_ORDER_DETAILS = 'update-order-details';
export const ADD_PRODUCT_TO_ALL_STORES = 'add-products-to-all-stores'